import { isArray, isEmpty, isObject } from '../is';
import { toArray } from '../transform/index';

export class List {
  constructor(...rest) {
    if (rest.length > 1) {
      this.value = rest;
    } else {
      this.value = toArray(rest[0]);
    }
  }

  static groupByLength({ target, length }) {
    if (!isArray(target) || isEmpty(target)) return [];
    const n = Math.ceil(target.length / length);
    const res = [];
    for (let i = 0; i < n; i++) {
      res.push(target.slice(i * length, i * length + length));
    }
    return res;
  }

  /**
   * 按照属性分组
   * @param {string} prop
   * @returns
   */
  groupBy(prop) {
    const list = this.value.filter(e => isObject(e));
    return new Group(list, prop);
  }

  filterBy(prop, types) {
    return new List(this.value.filter(e => types.includes(e[prop])));
  }

  /**
   * 转为Map
   * @param {string} prop
   */
  toMap(prop) {
    try {
      const list = this.value.filter(e => isObject(e));
      const map = list.reduce((map, e) => {
        map[e[prop]] = e;
        return map;
      }, {});
      return map;
    } catch (error) {
      console.error(error);
      return {};
    }
  }

  /**
   * 移除指定节点
   * @param {any} node
   */
  removeNode(node) {
    const index = this.value.findIndex(e => node === e);
    return this.value.splice(index, 1);
  }
}

class Group {
  constructor(list, prop) {
    this.value = Group.toGroup(list, prop);

    this.list = Object.values(this.value);
  }

  get(key) {
    return this.value[key];
  }

  static toGroup(list, prop) {
    if (!isArray(list)) return {};
    const group = list.reduce((map, e) => {
      const rest = prop.split('.');
      const val = rest.reduce((acc, cur) => {
        return acc && acc[cur] ? acc[cur] : null;
      }, e);

      if (map[val]) {
        map[val].items.push(e);
      } else {
        map[val] = { key: val, items: [e] };
      }
      return map;
    }, {});
    return group;
  }
}
